import { createMaterialTopTabNavigator } from 'react-navigation-tabs';
import Friends from '../screens/Friends';
import Home from '../screens/Home';
import ProfileNavigator from './ProfileNavigator';
import InboxStackNav from './InboxStackNav';
import NewMessageStackNav from './NewMessageStackNavWeb';
import CustomWebNavigation from '../components/customWebNavigation/CustomWebNavigation';

const MainTabNavigatorWeb = createMaterialTopTabNavigator(
  {
    Home: {
      screen: Home,
      navigationOptions: {
        title: 'Home',
      },
    },
    Turtlets: {
      screen: InboxStackNav,
      navigationOptions: {
        title: 'Turtlets',
      },
    },
    New_Turtlet: {
      screen: NewMessageStackNav,
      navigationOptions: {
        title: 'New Turtlet',
        headerShown: false,
        tabBarVisible: true,
      },
    },
    Friends: { screen: Friends },
    Profile: {
      screen: ProfileNavigator,
      navigationOptions: {
        headerShown: false,
        title: 'Profile',
      },
    },
  },
  {
    tabBarComponent: CustomWebNavigation,
    initialRouteName: 'Home',
    swipeEnabled: false,
    animationEnabled: false,
    gestureEnabled: false,
  },
);

export default MainTabNavigatorWeb;
